export default [
  {
    path: '/retargeting-audiences',
    name: 'PageRetargetingAudienceList',
    meta: { title: 'retargetingAudience.listTitle', roles: ['ADMIN'], permissions: ['retargeting_audience_view', 'retargeting_audience_edit'] },
    component: () => import('@/pages/retargeting-audience'),
  },
  {
    path: '/retargeting-audiences/create',
    name: 'PageRetargetingAudienceCreate',
    meta: { title: 'retargetingAudience.createFormTitle', roles: ['ADMIN'], permissions: ['retargeting_audience_edit'] },
    component: () => import('@/pages/retargeting-audience/create'),
  },
  {
    path: '/retargeting-audiences/:id/edit',
    name: 'PageRetargetingAudienceEdit',
    meta: { title: 'retargetingAudience.editFormTitle', roles: ['ADMIN'], permissions: ['retargeting_audience_view', 'retargeting_audience_edit'] },
    component: () => import('@/pages/retargeting-audience/id/edit'),
  },
]
